class GiolippoQuickView {
  constructor() {
    this.modal = document.querySelector('[data-quick-view-modal]');
    if (!this.modal) return;

    this.content = this.modal.querySelector('[data-quick-view-content]');
    this.loader = this.modal.querySelector('[data-quick-view-loader]');
    this.moneyFormat = this.modal.dataset.moneyFormat || '{{ amount }}';
    this.cartUrl = this.modal.dataset.cartUrl || '/cart/add';
    this.statusSelector = '[data-quick-view-status]';
    this.endpointsRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    this.bindEvents();
    this.enhanceCards();
    this.exists = true;
  }

  bindEvents() {
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('.giolippo-quick-view-trigger');
      if (!trigger || !trigger.dataset.productHandle) return;
      event.preventDefault();
      this.open(trigger.dataset.productHandle, trigger.dataset.quickViewTitle, trigger.dataset.quickViewUrl);
    });

    this.modal.addEventListener('click', (event) => {
      if (event.target.matches('[data-quick-view-close]')) {
        event.preventDefault();
        this.close();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.modal.classList.contains('is-open')) {
        this.close();
      }
    });

    this.modal.addEventListener('submit', (event) => {
      if (!event.target.matches('[data-quick-view-form]')) return;
      event.preventDefault();
      const formData = new FormData(event.target);
      if (!formData.get('quantity')) formData.append('quantity', '1');
      this.addToCart(formData);
    });

    document.addEventListener('shopify:section:load', (event) => {
      this.enhanceCards(event.target);
    });
  }

  enhanceCards(root = document) {
    const cards = root.querySelectorAll('[data-giolippo-quick-card]:not([data-quick-view-ready])');
    cards.forEach((card) => {
      const handle = card.dataset.giolippoHandle;
      if (!handle) {
        card.setAttribute('data-quick-view-ready', 'true');
        return;
      }

      const target = card.querySelector('[data-quick-view-target]') || card;
      if (!target) {
        card.setAttribute('data-quick-view-ready', 'true');
        return;
      }

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'giolippo-quick-view-trigger';
      button.dataset.productHandle = handle;
      const title = card.dataset.giolippoTitle || '';
      button.dataset.quickViewTitle = title;
      button.dataset.quickViewUrl = card.dataset.giolippoUrl || '';
      button.textContent = 'Vedi rapido';
      button.setAttribute('aria-label', title ? `Anteprima rapida di ${title}` : 'Anteprima rapida');
      target.appendChild(button);

      card.setAttribute('data-quick-view-ready', 'true');
    });
  }

  open(handle, title = '', url = '') {
    this.activeHandle = handle;
    this.activeTitle = title;
    this.activeUrl = url;
    this.modal.classList.add('is-open');
    this.modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('giolippo-quick-view-open');
    this.renderLoader();
    this.fetchProduct(handle);
  }

  close() {
    this.modal.classList.remove('is-open');
    this.modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('giolippo-quick-view-open');
  }

  renderLoader() {
    if (this.loader) {
      this.loader.hidden = false;
    }
    if (this.content) {
      this.content.innerHTML = this.loader ? this.loader.outerHTML : '<p>Caricamento...</p>';
    }
  }

  fetchProduct(handle) {
    const endpoint = `${this.endpointsRoot}products/${handle}.js`;
    fetch(endpoint)
      .then((response) => {
        if (!response.ok) throw new Error('Non riesco a caricare il prodotto.');
        return response.json();
      })
      .then((product) => this.renderProduct(product))
      .catch((error) => this.renderError(error.message));
  }

  renderProduct(product) {
    const imageSrc = (product.images && product.images.length > 0 && product.images[0]) || null;
    const variants = Array.isArray(product.variants) ? product.variants : [];
    const isAvailable = variants.some((variant) => variant.available);
    let firstAvailableSelected = false;
    let variantOptions = '';

    if (variants.length) {
      variantOptions = variants
        .map((variant) => {
          const disabled = variant.available ? '' : 'disabled';
          let selected = '';
          if (variant.available && !firstAvailableSelected) {
            selected = 'selected';
            firstAvailableSelected = true;
          }
          const label = variant.available ? '' : ' (esaurito)';
          return `<option value="${variant.id}" ${disabled} ${selected}>${this.escapeHtml(variant.title)}${label}</option>`;
        })
        .join('');
    } else {
      variantOptions = '<option value="" selected disabled>Nessuna variante disponibile</option>';
    }

    const selectId = `QuickViewVariant-${product.id}`;
    const excerpt = this.cleanText(product.description || product.body_html || '').slice(0, 280);
    const productUrl = this.activeUrl || product.url || `${this.endpointsRoot}products/${product.handle}`;
    const submitDisabledAttr = isAvailable ? '' : 'disabled';
    const selectDisabledAttr = variants.length ? '' : 'disabled';
    const defaultStatus = isAvailable ? '' : 'Attualmente non disponibile';

    const template = `
      <div class="giolippo-quick-view__body">
        <div class="giolippo-quick-view__media">
          ${
            imageSrc
              ? `<img src="${imageSrc}" alt="${this.escapeHtml(this.activeTitle || product.title)}">`
              : '<div class="placeholder">Nessuna immagine</div>'
          }
        </div>
        <div class="giolippo-quick-view__info">
          <span class="giolippo-quick-view__eyebrow">Anteprima rapida</span>
          <h3>${this.escapeHtml(this.activeTitle || product.title)}</h3>
          <p class="giolippo-quick-view__price">${this.formatMoney(product.price)}</p>
          <p class="giolippo-quick-view__excerpt">${excerpt || 'Dettagli disponibili nella scheda prodotto.'}</p>
          <form class="giolippo-quick-view__form" data-quick-view-form>
            <label for="${selectId}">Variante</label>
            <select id="${selectId}" name="id" ${selectDisabledAttr}>
              ${variantOptions}
            </select>
            <button type="submit" class="button button--primary" ${submitDisabledAttr}>Aggiungi al carrello</button>
            <a class="button button--secondary" href="${productUrl}">Apri scheda completa</a>
            <div class="giolippo-quick-view__status" data-quick-view-status aria-live="polite">${defaultStatus}</div>
          </form>
        </div>
      </div>
    `;

    this.content.innerHTML = template;
  }

  renderError(message) {
    this.content.innerHTML = `<div class="giolippo-quick-view__body"><p>${this.escapeHtml(message)}</p></div>`;
  }

  addToCart(formData) {
    this.setStatus('Aggiungo al carrello...');
    fetch(this.cartUrl, {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData,
    })
      .then((response) => response.json().then((data) => ({ ok: response.ok, data })))
      .then(({ ok, data }) => {
        if (!ok || (data && data.status === 'error')) {
          const message = (data && (data.message || data.description)) || 'Errore durante l\u2019aggiunta.';
          throw new Error(message);
        }
        this.setStatus('Aggiunto al carrello ✓');
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch((error) => this.setStatus(error.message, true));
  }

  setStatus(message, isError = false) {
    const statusEl = this.content.querySelector(this.statusSelector);
    if (!statusEl) return;
    statusEl.textContent = message;
    statusEl.style.color = isError ? '#d64545' : 'var(--verde-giolippo, #6a8370)';
  }

  formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, this.moneyFormat);
    }
    return `${(cents / 100).toFixed(2)} €`;
  }

  cleanText(text) {
    const withoutHtml = text.replace(/<[^>]*>?/gm, '');
    return this.escapeHtml(withoutHtml);
  }

  escapeHtml(string) {
    const div = document.createElement('div');
    div.textContent = string;
    return div.innerHTML;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const quickView = new GiolippoQuickView();
  if (quickView && quickView.exists) {
    window.giolippoQuickView = quickView;
  }
});
